import { InstanceScreen } from 'component/navigation/instance';

export default function ModerationDashboardBlocklistScreen() {
    return <InstanceScreen screenKey='blocklist' />;
}
